import { useEffect, useState } from "react";
import { api } from "../api/client";
import { BottomNav } from "../components/BottomNav";
import { TransactionCard } from "../components/TransactionCard";
import { currentPeriod, previousPeriod } from "../lib/format";
import type { Transaction, TransactionListResponse } from "../types";

function mergeByDate(lists: Transaction[][]): Transaction[] {
  const items = lists.flat();
  items.sort((a, b) => {
    const byDate = b.transaction_date.localeCompare(a.transaction_date);
    return byDate !== 0 ? byDate : b.id - a.id;
  });
  return items;
}

export function HistoryPage() {
  const [items, setItems] = useState<Transaction[]>([]);
  const [period, setPeriod] = useState<"recent" | string>("recent");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const periodQs = period === "recent" ? "" : `period=${period}&`;
        const [matched, excluded] = await Promise.all([
          api.request<TransactionListResponse>(
            `/transactions?${periodQs}status=matched&limit=100`,
          ),
          api.request<TransactionListResponse>(
            `/transactions?${periodQs}status=excluded&limit=100`,
          ),
        ]);
        if (!cancelled) {
          setItems(mergeByDate([matched.items, excluded.items]));
        }
      } catch {
        if (!cancelled) setItems([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [period]);

  return (
    <div className="app-shell">
      <header className="topbar">
        <h2 style={{ fontSize: "1.35rem" }}>Done</h2>
        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          aria-label="Period"
          style={{
            borderRadius: 999,
            border: "1px solid var(--line)",
            padding: "0.4rem 0.75rem",
            background: "#fff",
          }}
        >
          <option value="recent">All recent</option>
          <option value={currentPeriod()}>This month</option>
          <option value={previousPeriod()}>Last month</option>
        </select>
      </header>
      <div className="stack">
        {items.length === 0 && (
          <div className="panel muted">
            No matched or no-receipt transactions yet.
          </div>
        )}
        {items.map((txn) => (
          <TransactionCard
            key={txn.id}
            txn={txn}
            to={`/transactions/${txn.id}`}
            state={{ siblingIds: items.map((t) => t.id) }}
          />
        ))}
      </div>
      <BottomNav />
    </div>
  );
}
